module.exports = __webpack_public_path__ + "static/media/cover_extra.332ec6d5.jpg";